export const GEO_FORMATS = {
  ZONIER: "zonier",
  CODE_POSTAL: "code_postal",
};

export const IMPORT_STRATEGIES = {
  ALL: "all",
  NEW_ONLY: "new_only",
  UPDATE_ONLY: "update_only",
  REPLACE: "replace",
};

export const IMPORT_STEPS = {
  UPLOAD: "upload",
  MAPPING: "mapping",
  VALIDATION: "validation",
  VALUE_MAPPING: "valueMapping",
  GEO_ZONE: "geoZone",
  ANALYSIS: "analysis",
  IMPORTING: "importing",
  RESULT: "result",
};

export const REFERENTIAL_TYPES = {
  REGIME: "regime",
  BENEFICIARY_TYPE: "beneficiary_type",
  GEO_ZONE: "geo_zone",
};

export const CREATE_MODES = {
  UPLOAD: "upload",
  MANUAL: "manual",
};

export const ACCEPTED_FILE_EXTENSIONS = [".xls", ".xlsx", ".csv"];
export const FILE_ACCEPT_STRING = ".xls,.xlsx,.csv";

export const DEFAULT_RISK = "HEALTH";
export const REFERENTIAL_QUERY_LIMIT = 100;
export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export const PRICE_UNITS = {
  EURO: "euro",
  CENT: "cent",
};

export const CENTS_TO_EURO_DIVISOR = 100;

export const resolveError = (err, errorKeys) => {
  if (typeof err === "string") return err;
  if (!err || !err.key) return String(err);
  const template = errorKeys?.[err.key];
  if (!template) return err.key;
  const resolved = Object.entries(err.params || {}).reduce(
    (msg, [k, v]) => msg.replaceAll(`{{${k}}}`, v ?? ""),
    template,
  );
  return resolved.replace(/\s*\{\{[^}]+\}\}/g, "").trim();
};
